var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIconV524(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33331 2.66665C4.75598 2.66665 2.66665 4.75598 2.66665 7.33331C2.66665 9.91064 4.75598 12 7.33331 12C9.91064 12 12 9.91064 12 7.33331C12 4.75598 9.91064 2.66665 7.33331 2.66665ZM1.33331 7.33331C1.33331 4.0196 4.0196 1.33331 7.33331 1.33331C10.647 1.33331 13.3333 4.0196 13.3333 7.33331C13.3333 10.647 10.647 13.3333 7.33331 13.3333C4.0196 13.3333 1.33331 10.647 1.33331 7.33331Z",
    fill: "#45455A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6286 10.6286C10.8889 10.3682 11.311 10.3682 11.5714 10.6286L14.4714 13.5286C14.7317 13.7889 14.7317 14.211 14.4714 14.4714C14.211 14.7317 13.7889 14.7317 13.5286 14.4714L10.6286 11.5714C10.3682 11.311 10.3682 10.8889 10.6286 10.6286Z",
    fill: "#45455A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconV524);
export default __webpack_public_path__ + "static/media/search-icon-v5_24.b26cd0236bb52d6440f1b65a868aecf2.svg";
export { ForwardRef as ReactComponent };